<template>
  <div
    class="columns is-gapless is-vcentered is-multiline has-background-white is-border is-padding-right-small"
    v-if="selectedDocument">
    <div
      class="column is-padding-small is-narrow has-cursor-grab is-self-stretched is-flex level is-border-right"
      v-if="dragEnabled">
      <span class="is-size-3 has-text-grey"><i class="fal fa-grip-lines"></i></span>
    </div>
    <div
      class="column is-narrow is-border-right has-background-light is-padding-small"
      style="margin-left: 22.5px"
      v-if="imageValidation(selectedDocument.path) || (isPdf(selectedDocument.path) && currentTab === 'DOSSIER_RESERVATION')">
      <figure
        v-if="imageValidation(selectedDocument.path)"
        :style="{
          backgroundImage: 'url(' + selectedDocument.path + ')',
          transform: 'rotate(' + rotation + 'deg)'
        }"
        class="image is-96x96 level">
      </figure>
      <figure
        v-else-if="isPdf(selectedDocument.path) && currentTab === 'DOSSIER_RESERVATION'"
        :style="{
          transform: 'rotate(' + rotation + 'deg)'
        }"
        class="pdf-icon-container is-96x96">
        <i class="fal fa-file-pdf fa-4x has-text-danger"></i>
      </figure>
    </div>
    <div class="columns is-multiline column is-padding-left-small is-padding-top-small is-padding-bottom-small">
      <div class="column is-maxW550pX">
        <label
          for=""
          class="label is-small is-size-7 is-uppercase">Nom du fichier</label>
        <div class="field has-addons">
          <div class="control is-expanded">
            <v-input
              v-if="!edit"
              :id="'document' + selectedDocument.filename + index"
              :name="'documentFileName-' + selectedDocument.path"
              :model="filename"
              :errors-bag="errors"
              label=""
              v-validate="'required|min:2'"
              @input="val => initName(val)">
            </v-input>
          </div>
          <div
            class="is-padding-right is-padding-left is-flex is-align-items-center has-background-grey-lightest has-text-grey is-italic">
            .{{ extensionName }}
          </div>
          <div
            class="control"
            v-if="!askDelete">
            <span
              class="button is-square has-text-grey is-action tooltip"
              @click="download(selectedDocument)"
              data-tooltip="Télécharger">
              <i class="fal fa-download"></i>
            </span>
          </div>
          <div
            class="control"
            v-if="!imageValidation(selectedDocument.path) && !isPdf(selectedDocument.path) && !askDelete">
            <a
              class="button is-square has-text-grey is-action tooltip"
              @click="openPreview(selectedDocument)"
              data-tooltip="Aperçu">
              <i class="fal fa-external-link-alt"></i>
            </a>
          </div>
          <div
            class="control"
            v-if="imageValidation(selectedDocument.path) && !askDelete">
            <a
              class="button is-square has-text-grey is-action tooltip"
              @click="editDocument(selectedDocument, index)"
              data-tooltip="Recadrer l'image">
              <i class="fal fa-crop"></i>
            </a>
          </div>
          <div
            class="control"
            v-if="(imageValidation(selectedDocument.path) || isPdf(selectedDocument.path)) && !askDelete && currentTab === 'DOSSIER_RESERVATION'">
            <a
              class="button is-square has-text-grey is-action tooltip"
              @click="rotateDocument()"
              data-tooltip="Rotation 90°">
              <i class="fal fa-redo"></i>
            </a>
          </div>
          <div
            class="control"
            v-if="hasDestination && !askDelete && destinationsList.length">
            <multiselect
              v-model="destinations"
              class=" multiselect--option-ico"
              open-direction="bottom"
              track-by="key"
              label="label"
              :options="destinationsList.filter(x => x && x.enabled)"
              :placeholder="''"
              :multiple="true"
              :close-on-select="false"
              :show-labels="false"
              @input="editDestination($event, selectedDocument)">
              <span
                slot="placeholder"
                class="multiselect__placeholder">AFFECTATION</span>
              <span
                slot="selection"
                class="multiselect__placeholder"
                slot-scope="{ values }"
                v-if="values.length">
                <span>AFFECTATION</span>
              </span>
            </multiselect>
          </div>
          <div
            class="control"
            v-if="!askDelete">
            <a
              class="button is-square has-text-grey is-action tooltip"
              @click="askDelete = true"
              data-tooltip="Supprimer">
              <i class="fal fa-trash-alt"></i>
            </a>
          </div>
          <div
            class="control"
            v-if="askDelete">
            <a
              class="button has-text-white is-action is-danger"
              @click="deleteDocument(selectedDocument)">
              <span class="is-uppercase">Supprimer Document</span>
            </a>
          </div>
          <div
            class="control"
            v-if="askDelete">
            <a
              class="button is-square has-text-grey is-action tooltip"
              @click="askDelete = false"
              data-tooltip="Annuler suppression">
              <i class="fal fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="hasDestination && (hasPlaquette || hasContratDeReservation)"
        class="columns is-multiline is-gapless">
        <label class="label column is-12">&nbsp;</label>
        <div
          class="column is-narrow field is-grouped is-padding-top-small"
          v-if="hasPlaquette">
          <div class="control">
            <input
              :id="'destination-brochure' + selectedDocument.fus_id"
              :name="'destination-brochure' + selectedDocument.fus_id"
              type="checkbox"
              class="switch is-success is-rounded is-large"
              :value="{ label: 'Plaquette', key: 'brochure', enabled: false }"
              :disabled="!canEditBrochure || askDelete"
              v-model="hasBrochure"
              @input="editDestination({ label: 'Plaquette', key: 'brochure', enabled: false }, selectedDocument)">
            <label
              :for="'destination-brochure' + selectedDocument.fus_id"
              class="is-paddingless-top is-uppercase">
              <span class="is-size-6 is-padding-top-xsmall">Plaquette</span>
            </label>
          </div>
          <div
            class="control"
            v-if="hasContratDeReservation">
            <input
              :id="'destination-contrat_reservation' + selectedDocument.fus_id"
              :name="'destination-contrat_reservation' + selectedDocument.fus_id"
              type="checkbox"
              class="switch is-success is-rounded is-large"
              :value="{ label: 'Contrat de réservation', key: 'contrat_reservation', enabled: false }"
              :disabled="!canEditContratReservation || askDelete"
              v-model="hasContrat"
              @input="editDestination({ label: 'Contrat de réservation', key: 'contrat_reservation', enabled: false }, selectedDocument)">
            <label
              :for="'destination-contrat_reservation' + selectedDocument.fus_id"
              class="is-paddingless-top is-uppercase">
              <span class="is-size-6 is-padding-top-xsmall">Contrat de réservation</span>
            </label>
          </div>
        </div>
      </div>
      <div
        class="column is-12 is-paddingless-top"
        v-if="destinationsList.length">
        <div class="tags is-padding-top-xsmall">
          <span
            v-for="(d, i) in destinations.filter(x => x && x.enabled)"
            class="tag has-text-white has-background-grey"
            :key="i">
            {{ d | destinationLabel(destinationsList) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPlainObject } from 'lodash'

export default {
  name: 'UploadedFileItem',
  filters: {
    destinationLabel (v, destinationsList) {
      let dest = destinationsList.find(x => [v.key, v].includes(x.key))
      return dest ? dest.label : v
    }
  },
  props: {
    documents: Array,
    edit: {
      type: Boolean,
      required: false,
      default: false
    },
    document: {
      type: Object,
      required: true
    },
    editDisplayEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    dragEnabled: Boolean,
    hasDestination: Boolean,
    // mandatory if hasDestination is true
    destinationsList: {
      type: Array,
      default: () => []
    },
    currentTab: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      hasBrochure: false,
      hasContrat: false,
      selectedDocument: null,
      defaultFileName: null,
      destinations: [],
      askDelete: false,
      filename: '',
      extensionName: 'Null',
      rotation: 0
    }
  },
  computed: {
    canEditBrochure () {
      if (this.hasDestination && this.documents && this.documents.length) {
        let destinations = this.documents.map(x => {
          return { destination: x.destination, fus_id: x.fus_id }
        })
        let hasBrochure = destinations.find(x => x.destination.includes('brochure'))
        if (this.selectedDocument.destination.includes('brochure')) {
          return true
        } else if (!hasBrochure) {
          return true
        } else if (hasBrochure && hasBrochure.fus_id === this.selectedDocument.fus_id) {
          return true
        } else return false
      }
      return false
    },
    canEditContratReservation () {
      if (this.hasDestination && this.documents && this.documents.length) {
        let destinations = this.documents.map(x => {
          return { destination: x.destination, fus_id: x.fus_id }
        })
        let hasBrochure = destinations.find(x => x.destination.includes('contrat_reservation'))
        if (this.selectedDocument.destination.includes('contrat_reservation')) {
          return true
        } else if (!hasBrochure) {
          return true
        } else if (hasBrochure && hasBrochure.fus_id === this.selectedDocument.fus_id) {
          return true
        } else return false
      }
      return false
    },
    hasPlaquette () {
      if (this.hasDestination && this.destinationsList.length) {
        return !!this.destinationsList.find(x => x.key === 'brochure')
      }
      return false
    },
    hasContratDeReservation () {
      if (this.hasDestination && this.destinationsList.length) {
        return !!this.destinationsList.find(x => x.key === 'contrat_reservation')
      }
      return false
    }
  },
  watch: {
    document (v) {
      this.initDocument()
    }
  },
  mounted () {
    this.initDocument()
  },
  methods: {
    initDocument () {
      this.selectedDocument = this.document
      if (this.hasDestination && this.destinationsList.length) {
        if (!this.document.destination) {
          this.$set(this.selectedDocument, 'destination', [])
        }
        this.destinations = this.document.destination.map(x => {
          return this.destinationsList.find(y => [x.key, x].includes(y.key))
        })
        this.hasBrochure = this.document.destination.includes('brochure')
        this.hasContrat = this.document.destination.includes('contrat_reservation')
      }
      // Initialiser la rotation depuis le document si elle existe
      this.rotation = this.document.rotation || 0
      this.initName()
    },
    rotateDocument () {
      // Incrémenter la rotation de 90°, retour à 0 après 270°
      this.rotation = (this.rotation + 90) % 360
      // Sauvegarder la rotation dans le document
      this.$set(this.selectedDocument, 'rotation', this.rotation)
      // Émettre l'événement pour notifier le parent du changement
      this.$emit('rotateDocument', { document: this.selectedDocument, rotation: this.rotation })
    },
    imageValidation (value) {
      if (!value) return
      let ext = value.split('.')
      if (ext[ext.length - 1].match(/(jpg|png|jpeg|gif)/g)) return true
      else return false
    },
    isPdf (value) {
      if (!value) return false
      let ext = value.split('.')
      return ext[ext.length - 1].toLowerCase() === 'pdf'
    },
    download (file) {
      let link = document.createElement('a')
      const parts = file.filename.split('.')
      const cleanFilename = parts.slice(0, -1).join('.')
      const encoded = encodeURIComponent(cleanFilename).replace(/\./g, '%2E')
      link.href = file.path.replace(
        '/upload/',
        `/upload/fl_attachment:${encodeURIComponent(encoded)}/`
      )
      link.download = file.filename
      link.click()
    },
    openPreview (selectedDocument) {
      let params = {
        link: selectedDocument.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    // openPreview (selectedDocument) {
    // },
    editDocument (selectedDocument, index) {
      this.$emit('editDocument', { selectedDocument, index })
    },
    deleteDocument (document) {
      this.$emit('deleteDocument', document)
    },
    editDestination (destination, document) {
      if (isPlainObject(destination)) {
        let idx = document.destination.findIndex(x => x === destination.key)
        if (idx >= 0) {
          document.destination.splice(idx, 1)
        } else {
          document.destination.push(destination.key)
        }
      } else if (Array.isArray(destination)) {
        document.destination = destination.map(x => x.key || x)
      } else {
        document.destination.push(destination)
      }
    },
    test (e) {
      console.log(e)
    },
    initName (val) {
      if (val === undefined) {
        this.parseNameExtension(this.selectedDocument.filename)
      } else {
        this.filename = val
        this.selectedDocument.filename = this.filename + '.' + this.extensionName
      }
    },
    parseNameExtension (string) {
      let tab = string.split('.')
      if (tab.length > 1) {
        this.extensionName = tab.pop()
        tab.splice(tab.length, 1)
        this.filename = tab.join('.')
      } else {
        this.filename = tab.join('.')
      }
    }

  }
}
</script>

<style scoped>

.image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.3s ease;
}

.pdf-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  transition: transform 0.3s ease;
}

</style>
